import "../Main.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isNotHomePage = location.pathname !== "/";
  const isPartnershipActive = ["/partner", "/driver", "/franchisee"].includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => {
    const nav = document.getElementById("menu");
    if (nav && nav.classList.contains("show")) {
      nav.classList.remove("show");
    }
  };

  useEffect(() => {
    const nav = document.getElementById("menu");
    if (nav && nav.classList.contains("show")) {
      nav.classList.remove("show");
    }
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const nav = document.getElementById("menu");
      const toggler = document.querySelector(".navbar-toggler");
      if (nav && nav.classList.contains("show") && !nav.contains(event.target) && toggler && !toggler.contains(event.target)) {
        nav.classList.remove("show");
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  return (
    <div className="navbar-wrapper">
      <div id="headnav" className={`${scrolled ? "scrolled" : ""} ${isNotHomePage ? "other-navbar" : ""}`}>
        <nav className="navbar navbar-expand-lg w-100">
          <div className="content-container d-flex align-items-center justify-content-between w-100">
            <Link className="navbar-brand" to="/">
              <img src={scrolled ? "/Image/greenlogo2.png" : (isNotHomePage ? "/Image/sidelogo.png" : "/Image/main-logo.png")} alt="logo" className="logo" />
            </Link>
            
            <button 
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#menu"
              aria-controls="menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }}></span>
            </button>

            <div className="collapse navbar-collapse" id="menu">
              <div id="rightsidenav" className="ms-auto">
                <NavLink to="/aboutus">About Us</NavLink>
                <div className="dropdown">
                  <button 
                    className={`btn dropdown-toggle ${isPartnershipActive ? "active-link" : ""}`}
                    type="button" 
                    id="partnershipDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ background: "transparent", border: "none", color: scrolled ? "white" : "white", fontSize: "15px", fontWeight: "600" }}
                  >
                    Partnership
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="partnershipDropdown">
                    <li><NavLink className="dropdown-item" to="/partner" onClick={closeMenu}>Become a Merchant</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/driver" onClick={closeMenu}>Become a Driver</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/franchisee" onClick={closeMenu}>Become a Franchisee</NavLink></li>
                  </ul>
                </div>
                <NavLink to="/contactus">Contact Us</NavLink>
                <NavLink to="/popularmenu">Popular Menu</NavLink>
                <a 
                  id="getapp"
                  className={isNotHomePage ? "about-green" : ""}
                  href="https://play.google.com/store/apps/details?id=com.zustgo.customer"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get App
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
      </div>
  );
}

export default Navbar;